import React from 'react';

//Components
import Navbar from './components/navbar';

//Pages
import Home from './pages/Home';
import Nosotros from './pages/Nosotros';
import Equipo from './pages/Equipo';
import Servicios from './pages/Servicios';
import Footer from './pages/Footer';

import { FloatingWhatsApp } from 'react-floating-whatsapp'


function App() {
  return (
    <div className="min-h-screen">
      <Navbar />
       <div id='home'><Home /></div>
       <div id='nosotros'> <Nosotros /> </div>
       <div id='equipo'> <Equipo /></div> 
       <div id='servicios'> <Servicios /></div> 
       <div id='footer'> <Footer /></div> 
    
        {/** floating whatsapp icon */}
      <FloatingWhatsApp 
        phoneNumber='+54 9 3816 72-8112' 
        accountName='Gisela Barbero'
        avatar='https://media-eze1-1.cdn.whatsapp.net/v/t61.24694-24/473407149_559684070453047_4685088949981078800_n.jpg?ccb=11-4&oh=01_Q5AaIOc6YpotbPplhonsFsKFvPhdzd4p7-euyMWWrHdI_dmL&oe=67D88E88&_nc_sid=5e03e0&_nc_cat=105'
        chatMessage='Hola! 👋 ¿En qué puedo ayudarte?'
      />
    </div>
  );
}

export default App;
